import { Button, Space, Table } from "antd";
import { bankPoolTable } from "@configurations";
import {
  useAddExamGroupQuestion,
  useGetQuestions,
  useGetExamGroupQuestions,
} from "@hooks";
import { Exam, ExamGroup, ExamQuestionType } from "@types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  group: ExamGroup;
  exam?: Exam;
  setIsModalOpen: (value: boolean) => void;
}

export const BankPoolTable = ({ group, setIsModalOpen, exam}: Props) => {
  const { data, isLoading } = useGetQuestions({category: exam?.categories.map((c) => c.id)});
  const {t} = useTranslation();
  const addExamGroupQuestion = useAddExamGroupQuestion();
  const { data: examGroupQuestionsData, isLoading: examGroupQuestionLoading } =
    useGetExamGroupQuestions(group.id);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onFinish = () => {

    let questionsLenght = examGroupQuestionsData?.items.length || 0;
    const selectedQuestions = selectedRowKeys.map((id) => {
      return {
        QuestionId: id,
        OrderNumber: questionsLenght++,
      };
    });

    addExamGroupQuestion.mutate({
      groupId: group.id,
      QuestionsOrder: selectedQuestions,
    }, {onSuccess: () => {
      setSelectedRowKeys([]);
      setIsModalOpen(false);
    }});
  };

  return (
    <Space style={{ display: "flex" }} direction="vertical">
      <Table
        rowKey={(record) => record.id}
        rowSelection={{
          type: "checkbox",
          onChange: onSelectChange,
          getCheckboxProps(record) {
            console.log(exam?.isP365Exam && (record.questionType.id === ExamQuestionType.EssayQuestion || record.questionType.id === ExamQuestionType.ShortAnswer));
              if (exam?.isP365Exam && (record.questionType.id === ExamQuestionType.EssayQuestion || record.questionType.id === ExamQuestionType.ShortAnswer)) {
                  console.log("Disabling checkbox for record:", record);
                return { disabled: true };
              }
              console.log("Enabling checkbox for record:", record);
              return {};
          },
        }}
        dataSource={data?.items.filter(
          (item: any) =>
            !examGroupQuestionsData?.items.find((q: any) => q.id === item.id)
        )}
        loading={isLoading && examGroupQuestionLoading}
        size="middle"
        columns={bankPoolTable}
      />
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
        <Button
          type="primary"
          disabled={selectedRowKeys.length == 0}
          loading={addExamGroupQuestion.isPending}
          onClick={onFinish}
        >
          {t("forms.questions.save")}
        </Button>
      </div>
    </Space>
  );
};
